import GullyBoysImage from './gullyboys.jpg';
import PaperBeatsScissorsImage from './paperbeatsscissors.jpg';
import SaidTheWhaleImage from './saidthewhale.jpg';

export const testimonials = [
  {
    name: 'gullyboys',
    src: GullyBoysImage,
    text: 'Would absolutely work with Side Door again, they are artist centred and we felt supported on tour.',
    alt: 'Gully Boys',
  },
  {
    name: 'saidthewhale',
    src: SaidTheWhaleImage,
    text: 'Side Door has completely changed the way we approach touring.',
    alt: 'Said the Whale',
  },
  {
    name: 'paperbeatsscissors',
    src: PaperBeatsScissorsImage,
    text: 'It has really helped my touring, particularly outside of major centres, to become much more financially sustainable.',
    alt: 'Paper Beat Scissors',
  },
];
